import script from "./starPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./starPicker.vue?vue&type=script&setup=true&lang=ts"

import "./starPicker.vue?vue&type=style&index=0&id=6f8d767b&lang=scss"

const __exports__ = script;

export default __exports__